module.exports = ".textDec {\n  text-decoration: none; }\n\n.dtPickerPadding {\n  padding-top: 0px !important; }\n\n.mat-form-field {\n  width: 140px; }\n"